import { render, staticRenderFns } from "./business-port-modal.vue?vue&type=template&id=5ccf531c&scoped=true&"
import script from "./business-port-modal.vue?vue&type=script&lang=js&"
export * from "./business-port-modal.vue?vue&type=script&lang=js&"
import style0 from "./business-port-modal.vue?vue&type=style&index=0&id=5ccf531c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf531c",
  null
  
)

export default component.exports